"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconExpandLess = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var ExpandLess = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M13.0588 6.43934C12.473 5.85355 11.5233 5.85355 10.9375 6.43934L3.15931 14.2175C2.57352 14.8033 2.57352 15.753 3.15931 16.3388C3.7451 16.9246 4.69484 16.9246 5.28063 16.3388L11.9981 9.62132L18.7157 16.3388C19.3014 16.9246 20.2512 16.9246 20.837 16.3388C21.4228 15.753 21.4228 14.8033 20.837 14.2175L13.0588 6.43934Z" }))); };
exports.UtilIconExpandLess = (0, utils_1.withDeprecationWarning)(ExpandLess, 'UtilIconExpandLess');
exports.default = ExpandLess;
